import { IModuleConfig, LoginGuard, MenuKind } from '@simac/ui';

const webshopManagement = 'webshop-management';
const permissions = ['Module.Webshop.Management.CustomCategoryModify'];
export const WebshopManagerModuleConfig: IModuleConfig = {
  name: webshopManagement,
  components: [
    {
      name: 'Webshop custom category management',
      icon: 'far fa-tags',
      translateLabel: 'SSP.WEBSHOP.CUSTOMCATEGORYLABEL',
      permission: 'Module.Webshop.Management.CustomCategoryModify',
      pages: [
        {
          isDefault: true,
          route: 'category',
          loadComponent: () => import('../components/cus-category-management.component').then((m) => m.CusCategoryManagementComponent),
        },
        {
          isDefault: false,
          route: 'category/:id/product',
          loadComponent: () => import('../components/cus-product-management.component').then((m) => m.CusProductManagementComponent),
        },
      ],
    },
  ],
  routing: {
    menuKind: MenuKind.User,
    route: webshopManagement,
    children: [
      {
        title: 'MENU.WEBSHOPMANAGER',
        route: {
          path: '',
          loadComponent: () => import('../pages/webshop-manager.component').then((m) => m.WebshopManagerComponent),
          canActivate: [LoginGuard],
        },
        validForUser: (session) => session.permissions?.find((p) => permissions.includes(p)) !== undefined,
        icon: 'far fa-cart-arrow-up',
      },
    ],
  },
  breadCrumb: {
    default: [
      { key: webshopManagement, label: 'MENU.WEBSHOPMANAGER' },
      { key: 'part', label: '' },
      { key: 'detail', label: '' },
    ],
  },
};
